import React, { useState } from "react";
import { updateImageUrl } from "../../utils/utils";

export default function CusImage({ url, alt, height, weight, className = "" }) {
  // eslint-disable-next-line no-unused-vars
  const [imgError, setImgError] = useState(false);

  return (
    <img
      className={className}
      // src={imgError ? url : updateImageUrl(url)}
      src={updateImageUrl(url)}
      alt={alt}
      onError={() => setImgError(true)}
      height={height}
      width={weight}
    />
  );
}
